module.exports = function getResource(label) {
    const resources = {
        seeItInRealLife: 'Détails de la photo',
        addYourPhoto: '+ ajoutez votre photo',
        addAPhoto: 'Ajouter une photo',
        sorryNoImages: 'Désolés, aucune image ne correspond aux filtres appliqués.'
    };
    return resources[label];
};
